
import { SitemapURL } from './types';

/**
 * Generates an XML string for sitemap URLs
 */
export function generateSitemapXML(urls: SitemapURL[]): string {
  return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  ${urls.map(url => `
  <url>
    <loc>${url.loc}</loc>
    ${url.lastmod ? `<lastmod>${url.lastmod}</lastmod>` : ''}
    ${url.changefreq ? `<changefreq>${url.changefreq}</changefreq>` : ''}
    ${url.priority ? `<priority>${url.priority}</priority>` : ''}
  </url>`).join('')}
</urlset>`;
}

/**
 * Generates a sitemap index XML string
 */
export function generateSitemapIndex(siteUrl: string): string {
  const now = new Date().toISOString();
  const sitemaps = [
    { loc: `${siteUrl}/sitemaps/main.xml`, lastmod: now },
    { loc: `${siteUrl}/sitemaps/nursing-homes.xml`, lastmod: now },
    { loc: `${siteUrl}/sitemaps/counties.xml`, lastmod: now },
    { loc: `${siteUrl}/sitemaps/content.xml`, lastmod: now }
  ];

  return `<?xml version="1.0" encoding="UTF-8"?>
<sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  ${sitemaps.map(sitemap => `
  <sitemap>
    <loc>${sitemap.loc}</loc>
    <lastmod>${sitemap.lastmod}</lastmod>
  </sitemap>`).join('')}
</sitemapindex>`;
}
